<template>
  <div>
    <el-dialog
      :title="title"
      :width="width"
      :bottom="0"
      top="60px"
      :append-to-body="appendToBody"
      :modal-append-to-body="modalAppendToBody"
      :fullscreen="dialogFull"
      :close-on-click-modal="false"
      :visible.sync="visible"
      :destroy-on-close="true"
      :before-close="handleClose1"
      v-loading="loading"
      class="planManagement-addForm"
    >
      <template slot="title">
        <div class="avue-crud__dialog__header">
          <span class="el-dialog__title">
            {{ title }}
            <slot name="title" class="title"></slot>
          </span>

          <i
            class="el-icon-full-screen"
            style="margin-right: 20px; position: relative; top: -1px"
            @click="dialogFullChange"
          ></i>
        </div>
        <el-divider></el-divider>
      </template>
      <div class="content" :style="contentStyle">
        <slot name="body"></slot>
      </div>

      <div class="foot" v-if="$slots.hasOwnProperty('footer')">
        <!-- <el-divider></el-divider> -->
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    width: {
      default: '65%',
    },
    title: {
      default: '',
    },
    handleClose: {
      default: '',
    },
    visible: {
      default: false,
    },
    appendToBody: {
      default: true,
    },
    modalAppendToBody: {
      default: true,
    },
  },

  data() {
    return {
      dialogFull: false,
      dialogBodyHight: 0,
      dialogBodyWidth: 0,
      contentStyle: '',
    };
  },

  methods: {
    handleClose1() {
      this.$emit('update:visible', false);
      if (typeof this.handleClose == 'function') {
        this.handleClose();
      }
    },
    dialogFullChange() {
      let bodyHight = document.body.clientHeight;
      this.dialogFull = !this.dialogFull;
      if (this.dialogFull) {
        this.dialogBodyHight = bodyHight - 120;
        if (this.$slots.hasOwnProperty('footer')) {
          let footHeight = document.querySelector('.foot').clientHeight;
          let height = this.dialogBodyHight - footHeight;
          this.contentStyle = 'max-height:' + height + 'px;';
          this.contentStyle += ' margin-bottom: 40px;';
        } else {
          this.contentStyle = '';
        }
      } else {
        this.dialogBodyHight = bodyHight - 220;
        this.contentStyle = 'max-height:' + this.dialogBodyHight + 'px;';
      }
    },
  },
  mounted() {
    let bodyHight = document.body.clientHeight;
    //    let bodyWidth = document.body.clientWidth;
    this.dialogBodyHight = bodyHight - 220;
    if(this.$slots.hasOwnProperty('footer')){
        
        this.dialogBodyHight =this.dialogBodyHight-40-42
        console.log('减去了',this.dialogBodyHight)
    }
    // this.dialogBodyWidth = bodyWidth -560
    this.contentStyle = 'max-height:' + this.dialogBodyHight + 'px;';
    if (this.$slots.hasOwnProperty('footer')) {
      this.contentStyle += ' margin-bottom: 40px;';
    }

    console.log('$slots', this.$slots.footer != 'undefined');
    console.log('$slots11', this.$slots.hasOwnProperty('footer'));
  },
};
</script>
<style  scoped>
::v-deep .el-dialog.is-fullscreen {
  scrollbar-width: none; /* firefox */

  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
}
.content {
  padding: 0 24px;
  margin-top: -20px;
  /* box-sizing: border-box; */
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}
.foot {
  position: sticky;
  bottom: 10px;
  width: 100%;
  text-align: right;
  padding-right: 24px;
  z-index: 99;
  height: 40px;
}
/* .foot::before{
    display: block;
    content: '';
    overflow: hidden;
    height: 20px;
    background: yellow;
} */

::v-deep .el-dialog__body {
  padding: 20px 0 !important;
  position: relative;
}
.title {
  height: 24px;

  line-height: 24px;
}
</style>


